import React from 'react';
import styles from './TeleOp.module.css';
import shiftSvg from '../../static_files/shift.png'
import tabSvg from '../../static_files/tab.svg'
import { useIsMobile } from '../../utils/utils';

const KeyboardControls = ({
  keysPressed,
  isControlConnected,
  onVirtualKeyPress,
  onVirtualKeyRelease,
  robotId,
}) => {
  const isMobile = useIsMobile(1000);
  const hideGripKeys = robotId !== 'arm1' && robotId !== 'arm5'; // arm5 follows arm1 controls
  
  if (isMobile && !isControlConnected) {
    return null;
  }

  return (
  <div className={`${styles.keyboardSection} ${isControlConnected ? styles.controlConnected : ''}`}>
    <div className={styles.keyboardHeader}>
      <span className={styles.greenDot} />
      <span>Keyboard Layout</span>
      {isControlConnected && (
        <span style={{ marginLeft: 8, fontSize: 12, color: '#38CB89' }}>
          (Connected)
        </span>
      )}
    </div>

    <p className={styles.keyboardInfo}>
      You can either use your keyboard or the commands on the side to move the robotic arm.
    </p>

    <div className={styles.keyboardLayout}>
      <div className={styles.mainKeys}>
        {/* Row 1 */}
        <div className={styles.keyRow}>

          <button 
            className={`${styles.key} ${keysPressed.has('KeyQ') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('KeyQ')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyQ')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyQ')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('KeyQ');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyQ');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyQ');
            }}
          >Q</button>
          <button 
            className={`${styles.key} ${keysPressed.has('KeyW') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('KeyW')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyW')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyW')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('KeyW');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyW');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyW');
            }}
          >W</button>
          <button 
            className={`${styles.key} ${keysPressed.has('KeyE') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('KeyE')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyE')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyE')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('KeyE');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyE');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyE');
            }}
          >E</button>

        </div>

        {/* Row 2 */}
        <div className={styles.keyRow}>
          <button 
            className={`${styles.key} ${keysPressed.has('KeyA') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('KeyA')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyA')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyA')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('KeyA');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyA');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyA');
            }}
          >A</button>
          <button 
            className={`${styles.key} ${keysPressed.has('KeyS') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('KeyS')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyS')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyS')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('KeyS');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyS');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyS');
            }}
          >S</button>
          <button 
            className={`${styles.key} ${keysPressed.has('KeyD') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('KeyD')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyD')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyD')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('KeyD');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyD');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyD');
            }}
          >D</button>

        </div>

        {/* Row 3 */}
        <div className={styles.keyRow}>
          <button 
            className={`${styles.key} ${keysPressed.has('KeyZ') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('KeyZ')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyZ')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyZ')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('KeyZ');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyZ');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyZ');
            }}
          >Z</button>
          <button 
            className={`${styles.key} ${keysPressed.has('KeyX') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('KeyX')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyX')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyX')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('KeyX');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyX');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('KeyX');
            }}
          >X</button>
          {!hideGripKeys && (
            <button 
              className={`${styles.key} ${keysPressed.has('KeyC') ? styles.activeKey : ''}`}
              onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('KeyC')}
              onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyC')}
              onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyC')}
              onTouchStart={(e) => {
                e.preventDefault();
                onVirtualKeyPress && onVirtualKeyPress('KeyC');
              }}
              onTouchEnd={(e) => {
                e.preventDefault();
                onVirtualKeyRelease && onVirtualKeyRelease('KeyC');
              }}
              onTouchCancel={(e) => {
                e.preventDefault();
                onVirtualKeyRelease && onVirtualKeyRelease('KeyC');
              }}
            >C</button>
          )}
          {!hideGripKeys && (
            <button 
              className={`${styles.key} ${keysPressed.has('KeyV') ? styles.activeKey : ''}`}
              onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('KeyV')}
              onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyV')}
              onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('KeyV')}
              onTouchStart={(e) => {
                e.preventDefault();
                onVirtualKeyPress && onVirtualKeyPress('KeyV');
              }}
              onTouchEnd={(e) => {
                e.preventDefault();
                onVirtualKeyRelease && onVirtualKeyRelease('KeyV');
              }}
              onTouchCancel={(e) => {
                e.preventDefault();
                onVirtualKeyRelease && onVirtualKeyRelease('KeyV');
              }}
            >V</button>
          )}
        </div>
      </div>

      <div className={styles.arrowKeys}>
        <button 
          className={`${styles.arrowKey} ${keysPressed.has('ArrowUp') ? styles.activeKey : ''}`}
          onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('ArrowUp')}
          onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('ArrowUp')}
          onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('ArrowUp')}
          onTouchStart={(e) => {
            e.preventDefault();
            onVirtualKeyPress && onVirtualKeyPress('ArrowUp');
          }}
          onTouchEnd={(e) => {
            e.preventDefault();
            onVirtualKeyRelease && onVirtualKeyRelease('ArrowUp');
          }}
          onTouchCancel={(e) => {
            e.preventDefault();
            onVirtualKeyRelease && onVirtualKeyRelease('ArrowUp');
          }}
        >↑</button>
        <div className={styles.arrowRow}>
          <button 
            className={`${styles.arrowKey} ${keysPressed.has('ArrowLeft') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('ArrowLeft')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('ArrowLeft')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('ArrowLeft')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('ArrowLeft');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('ArrowLeft');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('ArrowLeft');
            }}
          >←</button>
          <button 
            className={`${styles.arrowKey} ${keysPressed.has('ArrowDown') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('ArrowDown')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('ArrowDown')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('ArrowDown')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('ArrowDown');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('ArrowDown');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('ArrowDown');
            }}
          >↓</button>
          <button 
            className={`${styles.arrowKey} ${keysPressed.has('ArrowRight') ? styles.activeKey : ''}`}
            onMouseDown={() => onVirtualKeyPress && onVirtualKeyPress('ArrowRight')}
            onMouseUp={() => onVirtualKeyRelease && onVirtualKeyRelease('ArrowRight')}
            onMouseLeave={() => onVirtualKeyRelease && onVirtualKeyRelease('ArrowRight')}
            onTouchStart={(e) => {
              e.preventDefault();
              onVirtualKeyPress && onVirtualKeyPress('ArrowRight');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('ArrowRight');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              onVirtualKeyRelease && onVirtualKeyRelease('ArrowRight');
            }}
          >→</button>
        </div>
      </div>
      {/*<div style={{display:'flex', flexDirection:'column', gap:'11px'}}>*/}
      {/*   <div className={styles.enterKey}>*/}
      {/*  <button className={styles.enterKeyBtn}>Enter</button>*/}
      {/*</div>*/}

      {/*<div className={styles.altArrows}>*/}

      {/*  <button className={styles.altArrowKey}><img style={{width:"12.5px", height:'17.5px'}} src={shiftSvg} alt='↑'/></button>*/}
      {/*</div>*/}
      {/*</div>*/}

    </div>
  </div>
  );
};

export default KeyboardControls;
